<div class="block-signal" [ngStyle]="{'backgroundColor': config.backgroundColor}">
    <div class="block-signal__summary">
        <div class="block-signal__value" [ngStyle]="{'color': config.color}">{{ config.value }}</div>
        <div class="block-signal__label" [ngStyle]="{'color': config.color}">{{ config.label }}</div>
    </div>
</div>
